import DatePicker from 'antd/lib/date-picker';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import Select from 'antd/lib/select';
import Spin from 'antd/lib/spin';
import Table from 'antd/lib/table';
import { InboxOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';

import { DATE_FORMAT } from '../constant/constants';

const EditableCell = (props) => {
  let inputNode;
  if (props.inputType === 'number') {
    inputNode = (
      <InputNumber
        key={props.record.id}
        min={0}
      />
    );
  } else if (props.inputType === 'text') {
    inputNode = (
      <Input
        key={props.record.id}
        maxLength={20}
      />
    );
  } else if (props.inputType === 'date') {
    inputNode = (
      <DatePicker
        key={props.record.id}
        format={DATE_FORMAT['MM/DD/YYYY']}
      />
    );
  } else if (props.inputType === 'dropdown') {
    const options = props.selectOptions();
    inputNode = (
      <Select
        key={props.record.id}
        onChange={props.onSelectChange}
        options={options}
      />
    );
  }

  return (
    <td key={props.title}>
      {props.editing ? (
        <Form.Item
          key={props.title}
          name={props.dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${props.title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        props.children
      )}
    </td>
  );
};

const PaginationCount = ({ total, range }) => (
  <span className='text-muted'>
    Showing {range[0]} to {range[1]} of {total} entries
  </span>
);

const showTotal = (total, range) => {
  return (
    <PaginationCount
      total={total}
      range={range}
    />
  );
};

const DataTable = ({
  rowClassName,
  columns,
  data,
  scroll,
  title,
  isSpinning,
  spinTip,
  isTableRowEditable,
  rowKey,
  handleChange,
  total,
  currentPage,
}) => {
  const paginationConfig = {
    showSizeChanger: true,
    total: total || data.length,
    defaultPageSize: 10,
    pageSizeOptions: ['10', '20', '50', '100'],
    locale: { items_per_page: '' },
    showTotal: showTotal,
    position: ['bottomCenter'],
    showQuickJumper: true,
  };

  if (currentPage) {
    paginationConfig.current = currentPage;
  }

  return (
    <div className='cb-table bg-surface border border-border rounded-xl shadow w-full overflow-hidden'>
      <Table
        size='middle'
        bordered={false}
        className='[&_.ant-table-thead>tr>th]:bg-bg [&_.ant-table-thead>tr>th]:text-text'
        components={
          isTableRowEditable
            ? {
                body: {
                  cell: EditableCell,
                },
              }
            : null
        }
        rowClassName={(record, index) =>
          `${rowClassName ? rowClassName(record, index) : ''} ${
            index % 2 === 0 ? 'bg-white' : 'bg-bg'
          } hover:bg-bg`
        }
        columns={columns}
        dataSource={data}
        rowKey={(record) => {
          return record[rowKey];
        }}
        scroll={scroll ? scroll() : undefined}
        title={() => title}
        loading={{
          indicator: (
            <Spin
              tip={spinTip ? spinTip : null}
              size='large'
            ></Spin>
          ),
          spinning: isSpinning,
        }}
        pagination={paginationConfig}
        sticky
        locale={{
          emptyText: (
            <div className='py-10 text-center'>
              <div className='mx-auto w-12 h-12 rounded-full bg-bg flex items-center justify-center mb-3'>
                <InboxOutlined className='text-muted' />
              </div>
              <div className='text-muted'>No data to display</div>
            </div>
          ),
        }}
        onChange={(pagination, filters) => {
          if (handleChange) {
            handleChange({ pagination, filters });
          }
        }}
      />
    </div>
  );
};

DataTable.propTypes = {
  isTableRowEditable: PropTypes.bool,
  rowClassName: PropTypes.func,
  columns: PropTypes.array,
  data: PropTypes.array,
  scroll: PropTypes.func,
  title: PropTypes.object,
  isSpinning: PropTypes.bool,
  spinTip: PropTypes.object,
  rowKey: PropTypes.string,
};

export default DataTable;
